import React from 'react'
import injectSheet from 'react-jss'
import style from './style'

const CalculatorLabelAndTextDisplay = ({ labelText, titleTag, bottomRowToggle, children, classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.extraWideLabel} title={titleTag || labelText}>{labelText}</div>
      <div className={bottomRowToggle ? classes.shortInputWrapper : classes.inputWrapper}>
        {children}
      </div>
    </div>
  )
}

export default injectSheet(style)(CalculatorLabelAndTextDisplay)



// WEBPACK FOOTER //
// ./src/components/CalculatorLabelAndTextDisplay/index.js